export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9240.41c8452d.jpg";